import {useSelector} from 'react-redux';
import {selectRsvpOff, selectType} from '~/CreateFabricInvitation/reducers/details/selectors';
import {GIFT_OPTIONS} from '~/CreateFabricInvitation/types/constants';
import {Charities} from './Charities';
import {Crowdfunding} from './Crowdfunding';
import {GiftIdeas} from './GiftIdeas';
import {HostPhotoGallery} from './HostPhotoGallery';
import {Photos} from './Photos';
import {Polls} from './Polls';
import {WhatToBring} from './WhatToBring';

import './GiftOption.sass';

export const GiftOption = ({
  name,
  shouldShowUpsellModal,
  setToToggleOff,
  setToToggleOn,
  toggleUpsellModal,
  setShowOverlay,
  ref,
}) => {
  const isFuneral = useSelector(selectType) === 'funeral_memorial_service';
  const rsvpOff = useSelector(selectRsvpOff);

  if (name === GIFT_OPTIONS.POLLS && rsvpOff) return null; // Hide Polls option if RSVP is off

  return (
    <div className="gift-option-wrapper" ref={ref}>
      {name === GIFT_OPTIONS.GIFTING && !isFuneral && (
        <GiftIdeas
          shouldShowUpsellModal={shouldShowUpsellModal}
          setToToggleOff={setToToggleOff}
          setToToggleOn={setToToggleOn}
          toggleUpsellModal={toggleUpsellModal}
        />
      )}
      {name === GIFT_OPTIONS.CHARITIES && (
        <Charities
          setShowOverlay={setShowOverlay}
          shouldShowUpsellModal={shouldShowUpsellModal}
          setToToggleOff={setToToggleOff}
          toggleUpsellModal={toggleUpsellModal}
        />
      )}
      {name === GIFT_OPTIONS.CROWDFUNDING && (
        <Crowdfunding
          setShowOverlay={setShowOverlay}
          shouldShowUpsellModal={shouldShowUpsellModal}
          setToToggleOff={setToToggleOff}
          toggleUpsellModal={toggleUpsellModal}
        />
      )}
      {name === GIFT_OPTIONS.PHOTOS && <Photos />}
      {name === GIFT_OPTIONS.HOST_PHOTO_GALLERY && (
        <HostPhotoGallery
          toggleUpsellModal={toggleUpsellModal}
          setToToggleOn={setToToggleOn}
          setToToggleOff={setToToggleOff}
        />
      )}
      {name === GIFT_OPTIONS.POLLS && <Polls />}
      {name === GIFT_OPTIONS.WHAT_TO_BRING && <WhatToBring />}
    </div>
  );
};
